export enum UmpireVisibilityOption {
  WEB = 'web',
  MOBILE = 'mobile',
}

export type UmpireVisibilityOptions = UmpireVisibilityOption[];
